package fr.frux.core.network

import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpHeaders
import io.ktor.http.fromHttpToGmtDate
import kotlin.time.Instant

/**
 * Corps de réponse accompagné de l'heure du serveur (en-tête `Date`), pour ancrer une échéance sur
 * le serveur plutôt que sur l'horloge de l'appareil (#527).
 *
 * [serverTime] vaut `null` quand l'en-tête manque ou ne se lit pas. Sur le web, `Date` n'est pas un
 * en-tête exposé par CORS : il y reste masqué, sans conséquence tant que le web n'a pas de publicité
 * (ADR 0030 point 7).
 */
data class ServerDated<out T>(
    val body: T,
    val serverTime: Instant?,
)

/** En-tête `Date` de la réponse, à la seconde près (RFC 9110). */
internal fun HttpResponse.serverTime(): Instant? =
    headers[HttpHeaders.Date]?.let { raw ->
        runCatching { Instant.fromEpochMilliseconds(raw.fromHttpToGmtDate().timestamp) }.getOrNull()
    }
